export interface BookConsultationButtonProps {
    isPro?: boolean;
    className?: string;
    withIcon?: boolean;
    theme?: Theme;
}

export enum Theme {
    grey = 'grey',
    lightGrey = 'light-grey',
}
